import { render, staticRenderFns } from "./OpenApiDocs.vue?vue&type=template&id=76d2a6fa"
import script from "./OpenApiDocs.vue?vue&type=script&lang=ts"
export * from "./OpenApiDocs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports